import React from 'react';
import PropTypes from 'prop-types';

import PageTitle from 'components/PageTitle';
import Button from 'components/Button';
import Input from 'components/Input';

const PhoneInput = ({ inputChangeHandl, phone, phoneReceiveHandl }) => (
  <React.Fragment>
    <PageTitle>
      Please, provide your phone
    </PageTitle>
    <p className="page-description">
      You will receive SMS confirmation next
    </p>

    <div className="phone-confirmation">
      <p className="phone-code">
        +1
      </p>
      <div className="phone-input">
        <Input
          type="tel"
          value={phone}
          masked="(999) 999-9999"
          changeHandl={inputChangeHandl}
        />
      </div>
    </div>

    <Button
      onClick={phoneReceiveHandl}
      disabled={phone.length !== 10}
    >
      Continue
    </Button>
  </React.Fragment>
);

PhoneInput.propTypes = {
  inputChangeHandl: PropTypes.func.isRequired,
  phone: PropTypes.string.isRequired,
  phoneReceiveHandl: PropTypes.func.isRequired
};

export default PhoneInput;



// WEBPACK FOOTER //
// ./src/pages/Phone/components/PhoneInput/index.js